import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, input, output } from '@angular/core';
import { MatTabsModule } from '@angular/material/tabs';
import { TranslateModule } from '@ngx-translate/core';

export interface Tab {
  label: string;
  disabled: boolean;
  path?: string;
  hide?: boolean;
  hasError?: boolean;
}

@Component({
  selector: 'lib-generic-tab-group',
  standalone: true,
  imports: [CommonModule, MatTabsModule, TranslateModule],
  templateUrl: './generic-tab-group.component.html',
  styleUrls: ['./generic-tab-group.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class GenericTabGroupComponent {
  tabs = input<Tab[]>([]);
  selectedTab = input(0);
  tabChange = output<number>();
}
